export default [{
  path: 'project/:leftid/:parent_id',
  name: 'backend_project',
  component: () => import('@/views/backend/admin/order/project/list/list'),
  meta: {
    tpflag: 'backend',
    title: '项目列表',
  }
}, {
  path: 'projectnew/:leftid/:parent_id',
  name: 'backend_projectnew',
  component: () => import('@/views/backend/admin/order/project/list/new'),
  meta: {
    tpflag: 'backend',
    title: '项目列表-新增项目',
  }
}]



// WEBPACK FOOTER //
// ./src/router/kdsuper/_project.js